(function () {
  // Match order success / failure URLs
  var href = window.location.href.toLowerCase();
  var isOrderResult =
    href.includes('thank-you') ||
    href.includes('thank_you') ||
    href.includes('failure') ||
    href.includes('failed');

  if (!isOrderResult) return;

  function hideFooter() {
    var footerGroup = document.querySelector('[app-target="footer-group"]');
    if (footerGroup) {
      footerGroup.style.display = 'none';
    }
  }

  // Run immediately
  hideFooter();

  // Run again after Shopify / theme JS hydration
  var tries = 0;
  var interval = setInterval(function () {
    hideFooter();
    tries++;
    if (tries > 20) clearInterval(interval); // ~4s max
  }, 200);
})();
